import noOp from "./noOp";
export { noOp as default, noOp as toClass };

//# sourceMappingURL=toClass.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/reassemble/lib/toClass.js
// module id = 216
// module chunks = 0